import { CloudArrowUpIcon } from "@heroicons/react/24/outline";
import { FingerPrintIcon } from "@heroicons/react/24/outline";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import { ArrowsRightLeftIcon } from "@heroicons/react/24/solid";
import { ArrowTrendingUpIcon } from "@heroicons/react/24/solid";
import React from "react";

function KeyFeatures(props) {
  const features = [
    {
      name: "Analytics Dashboard",
      description:
        "Dashboard analisis untuk membantu anda memberikan informasi yang akurat dan menyeluruh",
      icon: ArrowTrendingUpIcon,
    },
    {
      name: "Transaction Monitoring",
      description:
        "Memonitor status transaksi anda secara langsung dengan informasi yang detail dan akurat",
      icon: ArrowsRightLeftIcon,
    },
    {
      name: "Multi Platform",
      description:
        "Kemudahan integrasi dengan berbagai macam platform (Whatsapp, Jabber, API)",
      icon: ArrowPathIcon,
    },
    {
      name: "Transaksi Aman",
      description: "Transaksi secara aman dan dapat dipercaya",
      icon: FingerPrintIcon,
    },
  ];
  return (
    <div className="bg-white py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600">
            Fitur Utama
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Segala yang anda butuhkan untuk bertransaksi
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Kami menyediakan beberapa fitur utama untuk menunjang kebutuhan
            bisnis anda sehingga dapat memudahkan dan mempercepat proses bisnis
            anda
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
            {features.map((feature) => (
              <div key={feature.name} className="relative pl-16">
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-amber-500">
                    <feature.icon
                      className="h-6 w-6 text-white"
                      aria-hidden="true"
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-2 text-base leading-7 text-gray-600">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}

export default KeyFeatures;
